const messages = {
    'ph.pleseSelect': 'Please select...',
    'ph.pleseInput': 'Please input...',
    'ph.pleseInputEmail': 'Please enter email...',
    'ph.pleseInputRemark': 'Please enter remark...',
    'ph.poRequetNo':'PO Request No.',
    'ph.company':'Company',
    'ph.requestor':'Requestor',
    'ph.carriers':'Carriers',
    'ph.createdstart':'Create Start',
    'ph.createdend':'Create End',
    'ph.trackingno':'Tracking No',
    'ph.invoiceno':'Pre-invoice No.',
    'ph.dnno':'DN No.',
    'ph.status':'Status',
    'ph.warehouse':'Warehouse',
    'ph.pleseInputWidth': 'Width...',
    'ph.pleseInputLength': 'Length...',
    'ph.pleseInputHeight': 'Height...',
    'ph.mobile.pleaseInputAddressKey': 'Name/Phone No./Address...',
    'ph.mobile.pleaseInputExpressKey': 'Order No./Carrier Code...',
    'ph.mobile.pleseSelect': 'Please Select',
    'ph.mobile.pleseInput': 'Please Input...',
    'ph.mobile.expressorder.length': 'L(cm)',
    'ph.mobile.expressorder.width': 'W(cm)',
    'ph.mobile.expressorder.height': 'H(cm)',
    'ph.mobile.addressbook.copytip': 'Paste address, automatically fill in'
  };
  export default messages;
  